import { Route } from '@angular/router';

export interface RouteData {
  title?: string;
  breadcrumb?: string;
  analytics?: {
    name: string;
    section: string;
    prop13: string;
    eVar119?: string;
    loggedIn?: boolean;
    events?: string;
  };
  routeCode?: string;
  preload?: boolean;
}

export interface CignaStandardOutcome {
  status?: number;
  type?: string;
  message?: string;
  code?: number;
  developerMessage?: string;
  moreInfo?: string;
  additionalDetails?: any[];
}

export interface ServiceError {
  message: string;
  status: number;
  errObject: any | CignaStandardOutcome;
}

export interface CaRoute extends Route {
  data?: RouteData;
  children?: CaRoute[];
}

export declare type CaRoutes = CaRoute[];

export interface DropdownConfig {
  displayKey: string;
  search: boolean;
  height: string;
  placeholder: string;
  customComparator: () => void;
  limitTo: number;
  moreText: string;
  noResultsFound: string;
  searchPlaceholder: string;
  searchOnKey: string;
  clearOnSelection: boolean;
  inputDirection: string;
}

export interface MenuItem {
  text: string;
  icon: string;
  route: string;
  submenu?: MenuItem[];
  entitlement?: string | string[];
  isExternal?: boolean;
  open?: boolean;
  isTool?: boolean;
}
export interface GroupItem {
  text: string;
  id: string;
  cs1id?: string;
  internalProcGrpId: string;
  source: string;
  migrationStatus?: string;
  displayKeyFull?: string | null;
  lob?: string;
  productType?: { productTypeCd: string; productType: string };
}
export interface Menu {
  entitlementId: number;
  entitlement: string;
  sortOrder: number;
  isExternal: boolean;
  subMenus?: SubMenu[];
}
export interface SubMenu {
  entitlementId?: number;
  entitlement: string;
  sortOrder: number;
  isExternal: boolean;
  parentEntId: number;
  l3Menus?: SubMenu[];
}

export interface RouteTrack {
  channel: string;
  pageName: string;
}

export const lobByRoleIdData = [
  {
    lob: 'Commercial',
    roles: [56, 57, 58],
  },
  {
    lob: 'MA',
    roles: [62, 63, 64, 65, 66, 67, 68, 69, 70],
  },
  {
    lob: 'IFP',
    roles: [1, 2, 3, 4, 7, 8, 9, 11, 12, 13, 14, 16, 17, 18, 20, 21, 22, 23],
  },
  {
    lob: 'CSB',
    roles: [
      100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114,
      115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129,
      130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
      145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159,
      160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174,
      175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189,
      190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204,
      205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219,
      220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234,
      235, 236, 237, 76, 78, 81, 83, 84, 85, 86, 87, 88,
    ],
  },
];
